import { Component, Input } from '@angular/core';

@Component({
    selector: 'ssf-spinner',
    template: require('./spinner.component.html'),
    styles: [require('./spinner.component.scss')]
})
export class SpinnerComponent {
    @Input() show: boolean;
    public i18n = 'SHARED.SPINNER.';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/spinner/spinner.component.ts